import {
    type GetUploadTokenForContentPhotoResponseType,
    type GetUploadTokenForContentPhotoRequestType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForContentPhoto = async (params: GetUploadTokenForContentPhotoRequestType): Promise<GetUploadTokenForContentPhotoResponseType> => {
    return await request<GetUploadTokenForContentPhotoResponseType>("/content/getUploadTokenForContentPhoto", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default GetUploadTokenForContentPhoto;
